import { BsCloudDownload } from '@react-icons/all-files/bs/BsCloudDownload';
import { BsFiles } from '@react-icons/all-files/bs/BsFiles';
import { BsLayoutTextSidebar } from '@react-icons/all-files/bs/BsLayoutTextSidebar';
import React from 'react';
import Steps from '../../components/Steps';
import Step from '../../components/Steps/Step';

const Title = () => (
  <>
    How Email Studio <span className="text-indigo-600">works with Gmail?</span>
  </>
);

const HowItWorks = () => {
  return (
    <Steps video="https://www.youtube.com/embed/I9-480xTEOc" title={<Title />}>
      <Step Icon={BsLayoutTextSidebar} step="Step 1">
        Go to{' '}
        <a
          href="https://emailstudio.pro"
          target="_blank"
          rel="noopener noreferrer"
        >
          emailstudio.pro
        </a>{' '}
        and authorize the app with your Gmail account.
      </Step>
      <Step Icon={BsCloudDownload} step="Step 2">
        Select a service - scheduler, forwarder, responder, or clean-up - and
        create a rule.
      </Step>
      <Step Icon={BsFiles} step="Step 3" isLastStep>
        Configure the rule and save. The app runs in the background,
        automatically processing email messages as they are found.
      </Step>
    </Steps>
  );
};

export default HowItWorks;
